import React, { useState, useEffect } from 'react';

// Import CSS & assets
import ico_delete from '../../../assets/ico/ico_delete.svg';
import ico_locked from '../../../assets/ico/ico_locked.svg';

const FilterCatalogItem = ({ filter_data, handleFilterAdd_Click, searchParameters }) => {


    return (
        <div className="app__rulecatalog_rule_container">
            <div className="app__rulecatalog_rule_title">
                {filter_data.label}
            </div>
            <div className="app__rulecatalog_rule_box">
                <div className="app__rulecatalog_rule_body">
                    <div className="app__rulecatalog_rule_description">
                        {filter_data.description}
                    </div>
                </div>
                <div className="app__rulecatalog_rule_body_right" style={{ minHeight: '40px' }}>
                    {searchParameters?.filters_available && Object.keys(searchParameters.filters_available).includes(filter_data.id) ?
                        <div className="app__rulecatalog_rule_button_container">
                            <div className="app__rulecatalog_rule_button" onClick={() => { handleFilterAdd_Click(filter_data.id) }}>Ajouter ce critère</div>
                        </div>
                        :
                        <div className="app__rulecatalog_rule_button_container"><div className="app__sectiondata_catalog_text">Indisponible sur cette commune</div></div>
                    }
                </div>
            </div>
        </div>
    );
};

export default FilterCatalogItem;